import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService } from '../shared/services/authentication.service';
import { Screens, User } from '../shared/models/user';
import { NAVBAR_PROMPTS } from '../shared/ui-strings';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent {
    @Input() currentUser: User;
    @Input() screenAccessSet = new Set();
    @Input() userName: string;
    screens = Screens;
    navbarPrompts = NAVBAR_PROMPTS;
    fetchData = false;

    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
    ) { }

    logout(): void {
        this.authenticationService.logout();
        this.router.navigate(['/login']);
    }

    showMenuItem(screen: Screens): boolean {
       return this.screenAccessSet.has(screen);
    }
}
